"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLeadGenLoadingDetection;
var _react = require("react");
var _useScriptInjector = require("@site/pattern-library-utils/hooks/useScriptInjector");
var _leadGenScript = require("../lead-gen-script");
// Hook that listens for lead gen events from window messages
function useLeadGenLoadingEventListener(setIsLoading) {
  (0, _react.useEffect)(() => {
    function handleMessage(e) {
      if ((0, _leadGenScript.isLeadGenLoadLoadingEvent)(e)) setIsLoading(true);else if ((0, _leadGenScript.isLeadGenLoadSuccessEvent)(e) || (0, _leadGenScript.isLeadGenLoadErrorEvent)(e)) setIsLoading(false);
    }
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [setIsLoading]);
}

// Hook that detects if the script is loading based on script status
function useLeadGenScriptLoadingDetection(scriptStatus, setIsLoading) {
  const isScriptLoading = (0, _react.useMemo)(() => scriptStatus === _useScriptInjector.SCRIPT_STATUS.LOADING, [scriptStatus]);
  (0, _react.useEffect)(() => {
    if (isScriptLoading) {
      setIsLoading(true);
    }
  }, [isScriptLoading, setIsLoading]);
}

// Main hook that detects lead gen form is loading from multiple sources
function useLeadGenLoadingDetection(scriptStatus) {
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  useLeadGenScriptLoadingDetection(scriptStatus, setIsLoading);
  useLeadGenLoadingEventListener(setIsLoading);
  return isLoading;
}